export async function checkContractNo(to, from, next) {
	if (to.params.contract) {
		next();
	} else {
		next({ name: "corporateHome" })
	}
}

